import { Typography } from "antd"
import PropTypes from "prop-types"
import React, { useEffect, useMemo } from "react"
import { Link, useLocation } from "react-router-dom"
import styled from "styled-components"

import Menu from "../Menu"

// ----------------------------------------------------------------------------

function _Header(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, tabs } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const { pathname } = useLocation()

    const tabIndex = tabs?.findIndex((tab) => tab.href === pathname)

    // -------------------------------------
    // Effects
    // -------------------------------------

    const lineLeft = useMemo(() => {
        if (pathname === "/") {
            return 0
        } else {
            return tabIndex * 80
        }
    }, [tabIndex, pathname])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderTabs() {
        return (
            tabs?.length > 0 && (
                <div className="tabs">
                    <div className="tabs-content">
                        {tabs.map((tab) => {
                            const { label, href } = tab
                            return (
                                <div key={label} className="tabs-tab">
                                    <Link to={href}>{label}</Link>
                                </div>
                            )
                        })}
                    </div>
                    <div className="tabs-line" style={{ left: lineLeft }}></div>
                </div>
            )
        )
    }

    function getUserAppUrl() {
        if (process.env.NODE_ENV === "development") {
            return "http://localhost:3000"
        } else {
            return "https://www.unalloggio.it"
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <a href={getUserAppUrl()}>
                <img
                    src={"/assets/images/logo.png"}
                    width={"100%"}
                    height={50}
                />
            </a>
            {renderTabs()}
            <Menu />
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Header.propTypes = {
    className: PropTypes.string.isRequired,
    tabs: PropTypes.array,
}

_Header.defaultProps = {}

// ----------------------------------------------------------------------------

const Header = styled(_Header)`
    & {
        padding: ${(props) => props.theme.spacing.padding}
            ${(props) => props.theme.spacing.layoutPadding};
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
        position: relative;
        @media screen and (max-width: 992px) {
            padding: ${(props) => props.theme.spacing.padding} 24px;
        }
        @media screen and (max-width: 767px) {
            padding: ${(props) => props.theme.spacing.padding}
                ${(props) => props.theme.spacing.padding};
        }
        .logo {
            font-size: ${(props) => props.theme.font.logo.size};
            font-weight: ${(props) => props.theme.font.weight.bold};
            line-height: ${(props) => props.theme.font.logo.height};
            margin: 0;
        }
        .image-background & {
            position: absolute;
            left: 0;
            right: 0;
            box-shadow: none;
            color: ${(props) => props.theme.colors.light};
            .logo {
                color: ${(props) => props.theme.colors.light};
            }
        }
        .tabs {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            height: 100%;

            .tabs-content {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;

                .tabs-tab {
                    width: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    a {
                        display: block;
                        color: inherit;
                    }
                }
            }
            .tabs-line {
                position: absolute;
                top: 100%;
                left: 0;
                width: 80px;
                height: 3px;
                background-color: orange;

                transition: all 200ms ease;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default Header
